import React from 'react'
import * as Dropdown from 'component/base/Form/Dropdown'

export const KurikoshiUmuKbn = props => {
  return <Dropdown.Static kubunKey='kurikoshi_umu_kbn' {...props} />
}
